'use client';

import { useEnergyOffsetWithUpdates } from '@/ui/hooks/useEnergyOffset';
import { useFormDataInit } from '@/ui/hooks/useFormDataInit';
import { useResponsiveUi } from '@/ui/hooks/useResponsiveUi';
import { NoSSR } from '@/ui/utils/NoSSR';
import { Session } from 'next-auth';
import { AvatarMenu } from '../AvatarMenu';
import { BasicInfoMenu } from './BasicInfoMenu';
import { ContinueButton } from './ContinueButton';
import { EnergyBar } from './EnergyBar';
import styles from './EnergyUsageTopNav.module.css';

export const EnergyUsageTopNav: React.FC<{ session: Session }> = ({
    session,
}) => {
    useFormDataInit();

    const { inputComplete, loading, usageResult, errorMessage } =
        useEnergyOffsetWithUpdates();

    const showContinueButton =
        inputComplete && !loading && usageResult && !errorMessage;

    const { isMobile } = useResponsiveUi();

    const basicInfoMenu = (
        <div className={styles.infoMenu}>
            <BasicInfoMenu />
        </div>
    );

    const energyBar = <EnergyBar />;

    const rightEnd = (
        <div className={styles.rightEnd}>
            {showContinueButton && <ContinueButton />}
            <AvatarMenu session={session} />
        </div>
    );

    return (
        <NoSSR>
            <div className={styles.nav}>
                {isMobile ? (
                    <>
                        {energyBar}
                        <div className={styles.mobileSecondRow}>
                            {basicInfoMenu}
                            {rightEnd}
                        </div>
                    </>
                ) : (
                    <>
                        {basicInfoMenu}
                        {energyBar}
                        {rightEnd}
                    </>
                )}
            </div>
        </NoSSR>
    );
};
